import { MockMethod } from 'vite-plugin-mock';

export default [
    {
        url: '/mock/website/technology/category/list',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: [
                    {
                        tid: 1,
                        categoryCode: 'ar',
                        categoryName: 'AR交互技术',
                        categoryIntro: '掌握业内领先的AR增强现实交互技术，实现固定角色绑定驱动、高精度动作捕捉和虚拟现实融合，\r\n在现实场景（人、物）与虚拟场景（数字人、沉浸式场景）之间形成逻辑映射，搭建了现实世界与虚拟视界的桥梁，带来沉浸式交互体验。',
                        imageUrl: 'https://oss.zeewain.com/WEBSITE_RESOURCE/8307fd2b481f4c1ca2b004d2b5cffb9a/ar.jpg'
                    },
                    {
                        tid: 2,
                        categoryCode: 'ai',
                        categoryName: 'AI算法',
                        categoryIntro: '自主掌握图像、视频、语音、文本等跨媒体多元异构数据领域核心算法技术，拥有多模态表示学习、模态转化、对齐、融合、协同学习等关键技术，进行知识表征、挖掘、识别、检索和推理，实现对场景物性特征结构化感知和场景社会属性特征认知。',
                        imageUrl: 'https://oss.zeewain.com/WEBSITE_RESOURCE/4c43a5aa071047118cf1c33377050a64/ai.jpg'
                    },
                    {
                        tid: 3,
                        categoryCode: 'compute',
                        categoryName: '沉浸式计算',
                        categoryIntro: '通过压缩、量化、蒸馏等模型轻量化技术进行算法端算力优化，针对调用底层高性能计算技术，对交互引擎的图像模型和软件计算模型进行调优，减少图形渲染侧的算力消耗，进行网络精简，实现绿色计算。',
                        imageUrl: 'https://oss.zeewain.com/WEBSITE_RESOURCE/f72633b5d39444288ae82f10c1639d03/compute.jpg'
                    }
                ],
                message: 'success'
            };
        }
    },
    {
        url: '/mock/website/technology/info/list',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: [
                    {
                        categoryId: '1',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '通用物体和场景识别',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '2',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '2D手势识别',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '3',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '2D肢体识别',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '4',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '2D骨骼关键点识别',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '5',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '图形理解与生成',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '6',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '行人再识别',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '7',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '动态人像聚类',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '8',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '自然语言处理',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '9',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '语音识别',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '10',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '声纹鉴别',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '11',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '文字OCR',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '12',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '声纹鉴别',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '13',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '情绪识别',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    },
                    {
                        categoryId: '14',
                        previewUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/1278da21506b40108f3abc9c14e7792e/tl-01.jpg',
                        technologyName: '视频结构化',
                        technologyDesc: '对图像中的人物、动物、植物、日常用品等通用物体以及场景进行识别。'
                    }
                ],
                message: 'success'
            };
        }
    }
] as MockMethod[];
